<template>
  <div class="reference-clients-actions">
    <c-button
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: record.isWorker ? 'Снять метку сотрудника' : 'Отметить клиента как сотрудника',
        placement: 'top',
      }"
      class="reference-clients-actions-mark-as-employee"
      size="iconic"
      :icon="record.isWorker ? 'unmark-employee' : 'mark-as-employee'"
      @click="changeCustomerTypeRequest"
    />
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";

export default {
  name: "c-table-reference-clients-actions",

  components: {
    "c-button": Button,
  },

  props: ["record"],

  data() {
    return {};
  },

  methods: {
    changeCustomerTypeRequest() {
      this.$store
        .dispatch("referenceClients/changeCustomerType", {
          customerId: this.record.customerId,
          customerType: this.record.isWorker ? "client" : "worker",
        })
        .then((res) => {
          if (res.response.status === "success") {
            this.record.isWorker = !this.record.isWorker;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.reference-clients-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 8px;
}
</style>
